import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-948e9ffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "com_header_area" }
const _hoisted_2 = { class: "header_con" }
const _hoisted_3 = { class: "header_right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header_search" }, null, -1))
const _hoisted_5 = { class: "header_nav_title" }
const _hoisted_6 = {
  key: 0,
  class: "header_nav_child"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"font-size":"8px","vertical-align":"super"} }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        class: "logo",
        src: _ctx.logo,
        onClick: _ctx.toIndexPage
      }, null, 8, ["src", "onClick"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "header_nav",
          onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeOutShow && _ctx.changeOutShow(...args)))
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navListData, (item) => {
              return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                class: "header_nav_item",
                key: item.id,
                onMouseover: _withModifiers(($event: any) => (_ctx.changeHoverShow(item.id)), ["stop"]),
                to: item.url,
                style: _normalizeStyle({backgroundColor: item.id === _ctx.hoverId ? 'rgb(44,62,80)' : '',color:item.id === _ctx.hoverId ? '#fff' : ''})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${item.name}`)), 1)
                ]),
                _: 2
              }, 1032, ["onMouseover", "to", "style"])), [
                [_vShow, !(item.isNotShow?.includes(_ctx.locale))]
              ])
            }), 128))
          ]),
          (_ctx.navChildrenList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["header_child_con", _ctx.hoverId ? 'show' : ''])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navChildrenList, (item) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "header_child_item",
                      key: item.id
                    }, [
                      (item.isBlank)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: item.url,
                            target: "_blank"
                          }, _toDisplayString(_ctx.$t(`${item.name}`)), 9, _hoisted_7))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: item.url
                          }, {
                            default: _withCtx(() => [
                              (item.name === 'nav.EVIBB' && _ctx.locale != 'ja')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`nav.EVIBB01`)), 1),
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(`r`)), 1),
                                    _createTextVNode(_toDisplayString(_ctx.$t(`nav.EVIBB02`)), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t(`${item.name}`)), 1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                    ], 512)), [
                      [_vShow, !(item.isNotShow?.includes(_ctx.locale))]
                    ])
                  }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ])
  ]))
}